<template>
  <div class="container">
    <div class="spaced-row">
      <h3>User</h3>
      <div class="grow"></div>
      <mad-button color="brown" @click.prevent="deleteUser(id)">
        <mad-icon mdi="trash-can-outline" />Delete user
      </mad-button>
    </div>

    <mad-form @submit.prevent="submit">
      <mad-form-item label="Email">
        <mad-input v-model="form.email" />
      </mad-form-item>
      <mad-form-item label="First name">
        <mad-input v-model="form.first_name" />
      </mad-form-item>
      <mad-form-item label="Last name">
        <mad-input v-model="form.last_name" />
      </mad-form-item>
      <mad-form-item label="Last name">
        <mad-select
          v-model="form.admin"
          :options="[{value: true, label: 'Admin user'}, {value: false, label: 'Normal user'}]"
        />
      </mad-form-item>
      <mad-form-item label="User image">
        <image-input v-model="form.user_image" />
      </mad-form-item>

      <br>

      <mad-datatable :rows="rows" :columns="columns" :per-page="10">
        <template slot="locations" slot-scope="{row}">
          {{ row.name }}
        </template>
        <template slot="actions" slot-scope="{row}">
          <mad-button flat color="red" size="sm" @click="deleteLocation(row)">
            <mad-icon mdi="delete" />
          </mad-button>
        </template>
      </mad-datatable>

      <br>
      <br>

      <div class="spaced-row">
        <mad-button @click="clickCancel">
          <mad-icon mdi="arrow-left" />
        </mad-button>
        <div class="grow"></div>

        <mad-button color="brown" type="submit">
          <mad-icon mdi="check" />
          Save
        </mad-button>
      </div>
    </mad-form>
  </div>
</template>

<script>
import ImageInput from '.././inputs/ImageInput'

export default {
  components: {
    ImageInput,
  },

  props: {
    id: { type: String, required: true },
  },

  data: () => ({
    form: {
      email: '',
      first_name: '',
      last_name: '',
      user_image: '',
      admin: '',
      locations: [],
    },
    columns: [
      { key: 'name', sort: 'name' },
      { key: 'actions' },
    ],
  }),

  computed: {
    rows() {
      return this.form.locations.map(location => ({
        ...location,
        click: e => this.goToLocation(location),
      }))
    },
  },

  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      const user = await this.$store.dispatch('getUser', { id: this.id })
      this.form = user
    },

    async submit() {
      await this.$store.dispatch('updateUser', this.form)
      this.$mad.message.success('User updated succesfully')
      this.$router.push('/users')
    },

    async deleteUser(id) {
      const confirmed = confirm(
        `Deleting user ${this.form.email}, are you sure?`
      )
      if (!confirmed) return
      await this.$store.dispatch('deleteUser', { id: this.form.id })
      this.$mad.message.success('User deleted')
      this.$router.push('/users')
    },

    goToLocation(location) {
      this.$router.push(`/locations/${location.id}`)
    },

    clickCancel() {
      this.$router.push(`/users`)
    },
  },
}
</script>

<style>
</style>
